import LargeLayout from './LargeLayout';

export default LargeLayout;
